<template>
    <div ref="filterModal" id="filter-modal">
        <div class="filters-content" @click="toggle()">
            <slot />
        </div>
        <div class="filters-dropdown" :class="[align]" v-if="hasSlot('content') && isActive" ref="filterDropdown">
            <div class="filter-dropdown-head">
                <div class="title">{{ $t("visitor.saveSearchFavorite") }}</div>
            </div>
            <div class="filter-dropdown-content">
                <div class="filter-input-group">
                    <div class="title">{{ $t("visitor.filterName") }}</div>
                    <div class="body">
                        <a-input v-model="name" />
                    </div>
                </div>
            </div>
            <div class="filter-dropdown-footer" :class="{ large: !!value }">
                <div v-if="value">
                    <SupsisButton primary small @click="deleteAction">
                        <a-icon type="delete" />
                    </SupsisButton>
                </div>
                <div class="modal-actions">
                    <SupsisButton ghost small @click="isActive = false"> {{ $t("message.cancel")}}</SupsisButton>
                    <SupsisButton primary small @click="saveAction"> {{ $t("message.save")}}</SupsisButton>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SupsisButton from "../../Settings/components/SupsisButton.vue";

export default {
    name: "SaveFilterModal",
    components: { SupsisButton },
    props: {
        align: {
            type: String,
            default: "bottom",
        },
        active: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: null,
        },
    },
    data: () => {
        return {
            name: null,
            isActive: false,
        };
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
            if (this.isActive) this.$refs.filtersModal?.focus();
        },
        hasSlot(name) {
            return !!this.$slots[name];
        },
        saveAction() {
            this.isActive = false;
            this.$emit("save", this.name);
        },
        deleteAction() {
            this.isActive = false;
            this.$emit("delete");
        },
    },
    mounted() {
        this.name = this.value;
        document.addEventListener("click", (e) => {
            if (!this.$refs.filterModal?.contains(e.target)) {
                this.isActive = false;
            }
        });
    },
    watch: {
        active() {
            if (this.active !== this.isActive) {
                this.isActive = !!this.active;
            }
        },
        isActive(newVal) {
            if (this.active !== this.isActive) {
                this.$emit("changeActive", newVal);
            }
        },
        value() {
            if (this.value !== this.name) {
                this.name = this.value;
            }
        },
    },
};
</script>
<style lang="scss">
#filter-modal {
    position: relative;
    user-select: none;
    display: block;

    span {
        display: block;
    }

    .filter-dropdown-back {
        .material-icons {
            cursor: pointer;
        }
    }

    .filters-dropdown {
        position: absolute;
        background-color: var(--color-bg-neutral-default);
        border: 1px solid var(--color-border-default);
        border-radius: 4px;
        z-index: 9999;
        overflow: hidden;
        width: 300px !important;

        .filter-dropdown-head {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 13px;
            background: var(--color-bg-neutral-default);
            width: 100%;
            color: var(--default-text-color);
            border-bottom: 1px solid var(--color-border-default);
            .title {
                font-size: 14px;
                font-weight: 500;
            }
        }

        &.bottom {
            top: calc(100% + 4px);
        }

        &.top {
            bottom: calc(100% + 4px);
        }

        .filters-head {
            display: flex;
            align-items: center;
            justify-content: center;
            background: #1e1e2d !important;
            padding: 4px 15px;
            border-radius: 5px 5px 0px 0px;
            color: var(--default-text-color);
            font-weight: bold;
            font-size: 14px;
            width: 100%;
        }

        .filter-dropdown-content {
            display: flex;
            padding: 10px;
            width: 100%;
            color: var(--default-text-color);
            .filter-input-group {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 4px;
                width: 100%;

                .title {
                    font-size: 14px;
                }

                .body {
                    width: 100%;
                }
            }
        }

        .filter-dropdown-footer {
            display: flex;
            justify-content: flex-end;
            gap: 5px;
            align-items: center;
            width: 100%;
            border-top: 1px solid #dddddd;
            padding: 10px;

            &.large {
                justify-content: space-between;
            }

            .modal-actions {
                display: flex;
                align-items: center;
                gap: 5px;
            }
        }
    }
}
</style>
